'use client'

/* ---------------------------------
ProgressCard
--------------------------------- */

import { Avatar, Card, ProgressBar } from 'components/atoms'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default function ProgressCard({
  figures,
  testimonials = (
    <Avatar
      variant={'embedded'}
      numberOfAvatar={3}
      // Necessary to undo the label
      // since it has a default value.
      label={''}
    />
  ),
  ctaMessage,
  className,
}) {
  return (
    <Card className={classNames('ProgressCard', className)}>
      {figures ? (
        <div className='ProgressCard__figures'>
          <span className='ProgressCard__figures__part'>{figures.part}</span>

          <span className='ProgressCard__figures__whole'>/{figures.whole}</span>

          <span className='ProgressCard__figures__unit'>
            {' '}
            {figures.unit} raccolti
          </span>
        </div>
      ) : null}

      {figures ? (
        <div className='ProgressCard__progress'>
          <ProgressBar
            progress={{ part: figures.part, whole: figures.whole }}
          />
        </div>
      ) : null}

      {/*
        We have a default value, but we'll keep the conditional in case
        the field is explicitly set to null
       */}
      {testimonials ? (
        <div className='ProgressCard__testimonials'>{testimonials}</div>
      ) : null}

      {ctaMessage ? (
        <div className='ProgressCard__cta-message'>{ctaMessage}</div>
      ) : null}
    </Card>
  )
}

ProgressCard.propTypes = {
  figures: PropTypes.shape({
    part: PropTypes.number.isRequired,
    whole: PropTypes.number.isRequired,
    unit: PropTypes.string.isRequired,
  }).isRequired,
  testimonials: PropTypes.node,
  ctaMessage: PropTypes.string,
}
